import ApiService from "@/api.service";
import API from "@/API";

export const GET_DATA_SEARCH_REGION = "getRegions";
export const SET_DATA_SEARCH_REGION = "setRegions";


const state = {
    regions: [],
};

const getters = {
    regions(state) {
        return state.regions;
    },
};

const actions = {
    [GET_DATA_SEARCH_REGION](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_DATA_SEARCH_REGION, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_REGION, data.data);
                }
                resolve(data);
            });
        });
    }
};

const mutations = {
    [SET_DATA_SEARCH_REGION](state, data) {
        state.regions = data
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};